export function numericPageUid5(microPrefix, slug) {
  const input = `${microPrefix}::${slug}`;
  const hash = Math.abs(hash53(input)) % 100_000;
  return String(hash).padStart(5, '0');
}

function hash53(str) {
  let h1 = 0xde_ad_be_ef ^ str.length;
  let h2 = 0x41_c6_ce_57 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2_654_435_761);
    h2 = Math.imul(h2 ^ ch, 1_597_334_677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2_246_822_507) ^ Math.imul(h2 ^ (h2 >>> 13), 3_266_489_909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2_246_822_507) ^ Math.imul(h1 ^ (h1 >>> 13), 3_266_489_909);
  return ((h2 & 0x1f_ff_ff) * 0x1_00_00_00_00) + (h1 >>> 0);
}

export function normalizePathname(pathname = '/') {
  let p = String(pathname || '/').split('#')[0].split('?')[0];
  if (!p.startsWith('/')) p = `/${p}`;
  if (p !== '/' && !p.endsWith('/')) p += '/';
  return p;
}
